import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
import { useStore } from '@/store';
import { FETCH_PROJECTS } from '@/store/types/actions';


export default /*#__PURE__*/_defineComponent({
  __name: 'DCStreaks',
  setup(__props) {

const store = useStore();

onMounted(() => {
  store.dispatch(FETCH_PROJECTS);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_component_RouterView))
}
}

})